/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelSavingsLedgerGet$Params {
  date1?: string;
  date2?: string;
  entityID?: string;
}

export function apiExcelExcelSavingsLedgerGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelSavingsLedgerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelSavingsLedgerGet.PATH, 'get');
  if (params) {
    rb.query('date1', params.date1, {});
    rb.query('date2', params.date2, {});
    rb.query('entityID', params.entityID, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelSavingsLedgerGet.PATH = '/api/Excel/Excel_SavingsLedger';
